import CommonStyles from "../../common/CommonStyles";

export default {
  notificationGoToTalks: {
    position: 'absolute',
    right: 'calc(50% - 220px)',
    //transform: 'translateX(-50%)',
    padding: '3px',
    transition: 'none !important',
    background: '#222029 !important',
    minWidth: '400px',
    maxWidth: '800px',
    minHeight: '29px',
    marginBottom: '5px',
    opacity: 0.9,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loaderLine: {
    position: 'absolute',
    bottom: 0,
    height: '3px',
    backgroundColor: "#FFF",
    opacity: 0.9,
    animation: "$line 2s linear infinite",
    left: '-50%',
    width: '20%',
    "&:before": {
      content: '""',
      position: 'absolute',
      height: '3px',
    }
  },
  '@keyframes line': {
    '0%': {
      left: '-40%',
    },
    '30%': {
      left: '20%',
      width: '30%',
    },
    '60%': {
      left: '60%',
      width: '40%',
    },
    '100%': {
      left: '100%',
      width: '30%',
    }
  },
  customEnter: {
    transform: 'none !important',
    opacity: '1 !important',
  },
  customExit: {
    transform: 'none !important',
    opacity: '1 !important',
  },
  toastNormal: {
    height: 'auto !important',
    transition: 'height 0.2s ease',
  },
  toastMinimized: {
    height: '5px !important',
    overflow: 'hidden',
    transition: 'height 0.2s ease',
  },
  notificationRow: {
    '&:hover': {
      backgroundColor: '#1B1920 !important',
    },
  },
  notificationActionBtn: {
    fontSize: 10,
    minHeight: '17px',
    padding: '0px 6px',
    width: 'fit-content',
    textTransform: 'none',
    borderRadius: '10px',
    backgroundColor: '#E8E9F4',
    color: '#222029',
    opacity: '0.8',
    '&:hover': {
      opacity: '1.0',
      backgroundColor: '#E8E9F4',
      color: '#222029',
    },
  },
  ...CommonStyles,
};
